/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ keyName: NonNullable<unknown> }} Settings_Reportingapikeys_Generate_Replacewarning3Inputs */

const en_settings_reportingapikeys_generate_replacewarning3 = /** @type {(inputs: Settings_Reportingapikeys_Generate_Replacewarning3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A key named ${i?.keyName} already exists for this user. Generating will replace it – the current key stops working immediately.`)
};

/**
* | output |
* | --- |
* | "A key named {keyName} already exists for this user. Generating will replace it – the current key stops working immediately." |
*
* @param {Settings_Reportingapikeys_Generate_Replacewarning3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_reportingapikeys_generate_replacewarning3 = /** @type {((inputs: Settings_Reportingapikeys_Generate_Replacewarning3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Reportingapikeys_Generate_Replacewarning3Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_reportingapikeys_generate_replacewarning3(inputs)
});
export { settings_reportingapikeys_generate_replacewarning3 as "settings_reportingApiKeys_generate_replaceWarning" }